import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Clock, ArrowLeft, Sparkles } from 'lucide-react';

/**
 * ComingSoon — friendly placeholder for routes that are mapped in the UI but
 * not yet built (replaces blank pages at /import and /activity-logs).
 */
const ComingSoon = ({ title = 'Coming Soon', description, icon: Icon = Clock }) => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col items-center justify-center text-center py-20 px-6" data-testid="coming-soon">
      <div className="h-16 w-16 rounded-2xl bg-gradient-to-br from-teal-500 to-emerald-600 flex items-center justify-center shadow-lg mb-5">
        <Icon className="h-8 w-8 text-white" />
      </div>
      <div className="inline-flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wide text-teal-600 bg-teal-50 px-2.5 py-1 rounded-full mb-3">
        <Sparkles className="h-3 w-3" /> Coming Soon
      </div>
      <h1 className="text-2xl font-bold text-slate-800 mb-2" data-testid="coming-soon-title">{title}</h1>
      <p className="text-sm text-slate-500 max-w-md mb-6">
        {description || "We're building this out. Check back shortly — it'll be worth the wait."}
      </p>
      <Button variant="outline" onClick={() => navigate(-1)} data-testid="coming-soon-back">
        <ArrowLeft className="h-4 w-4 mr-2" /> Go back
      </Button>
    </div>
  );
};

export default ComingSoon;
